import React from 'react';
import PropTypes from 'prop-types';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import { FormattedMessage, injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import messages from './messages';
import { hasAssignments } from '@/shared/components/security/HasAssignments';

const GlobalActionsButton = props => {
  const {
    intl,
    disabled,
    onCreatePlannedRegistrations,
    onRemovePlannedRegistrations,
    onSendMail,
    onCreateRegistration,
    onChangeUser,
    onChangeAssignment,
    onUpdateRelationTags,
    hasWithoutFilter,
    inProgress,
  } = props;

  return (
    <span className="tool-tip" data-toggle="tooltip" data-placement="top">
      <DropdownButton
        bsSize="xsmall"
        bsStyle="default"
        className="btn-inverse"
        id="global-actions-button"
        disabled={disabled || inProgress}
        pullRight
        title={
          <span>
            {inProgress && <i className="fa fa-spinner fa-spin margin5R" />}
            <FormattedMessage {...messages.GlobalActions} />
          </span>
        }
      >
        <MenuItem
          onSelect={onCreatePlannedRegistrations}
          id="global-actions-button-AddPlannedRegistrations"
        >
          {intl.formatMessage(messages.AddPlannedRegistrations)}
        </MenuItem>
        <MenuItem
          onSelect={onRemovePlannedRegistrations}
          disabled={hasWithoutFilter}
          id="global-actions-button-RemovePlannedRegistrations"
        >
          {intl.formatMessage(messages.RemovePlannedRegistrations)}
        </MenuItem>
        <MenuItem
          onSelect={onChangeUser}
          disabled={hasWithoutFilter}
          id="global-actions-button-ChangeUser"
        >
          {intl.formatMessage(messages.ChangeUser)}
        </MenuItem>
        {hasAssignments() ? (
          <MenuItem
            onSelect={onChangeAssignment}
            disabled={hasWithoutFilter}
            id="global-actions-button-ChangeAssignment"
          >
            {intl.formatMessage(messages.ChangeAssignment)}
          </MenuItem>
        ) : null}

        <MenuItem onSelect={onCreateRegistration} id="global-actions-button-create-registration">
          {intl.formatMessage(messages.CreateSingleRegistration)}
        </MenuItem>
        <MenuItem onSelect={onSendMail} id="global-actions-button-SendEmail">
          {intl.formatMessage(messages.SendEmail)}
        </MenuItem>
        <MenuItem onSelect={onUpdateRelationTags} id="global-actions-button-onUpdateRelationTags">
          {intl.formatMessage(messages.AddTagToRelation)}
        </MenuItem>
      </DropdownButton>
    </span>
  );
};

GlobalActionsButton.propTypes = {
  intl: intlShape.isRequired,
  onCreatePlannedRegistrations: PropTypes.func.isRequired,
  onRemovePlannedRegistrations: PropTypes.func.isRequired,
  onSendMail: PropTypes.func.isRequired,
  onCreateRegistration: PropTypes.func.isRequired,
  onChangeUser: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  inProgress: PropTypes.bool,
  hasWithoutFilter: PropTypes.bool,
};
GlobalActionsButton.defaultProps = { disabled: false, inProgress: false, hasWithoutFilter: false };
export default injectIntl(GlobalActionsButton);
